import _get from 'lodash/get';
import {
  mergeDisplayError,
  mergeServiceTypeAndSpecialServiceType,
} from 'helper/anytime-booking';

const countryWithSpecialService = ['VN', 'SG', 'TH', 'ID'];

const generateServiceTypesToRender = (serviceTypes, dropOffs, countryCode) =>
  serviceTypes
    .reduce(
      (serviceTypesToRender, serviceType) => [
        ...serviceTypesToRender,
        ...serviceType.specialServices
          // do not show special services
          // [VN https://jira.grab.com/browse/DELVEXPS-20331]: display special service types
          // [SG https://jira.grab.com/browse/DELVEXPS-23164]
          .filter(
            specialService =>
              countryWithSpecialService.includes(countryCode)
                ? true
                : specialService.id === 'None',
          )
          .map(specialService => {
            const maxDropOff = _get(serviceType, 'maxDropOff.value', 1);
            const errorMessage = _get(serviceType, 'errorMessage');
            const { reason, hint } = mergeDisplayError(errorMessage);
            return mergeServiceTypeAndSpecialServiceType(
              serviceType,
              specialService,
              maxDropOff < dropOffs.length || errorMessage,
              reason,
              hint,
            );
          }),
      ],
      [],
    )
    .sort((st1, st2) => (st1.displayPosition > st2.displayPosition ? 1 : -1));

export default generateServiceTypesToRender;
